import './style/index.less'
import { EventName } from "@/api/event/common";
import { SocketMgr } from "@/Core/net/socket/SocketMgr";
import { useBeforeSetting } from "@/store/beforeSetting";
import EventMgr from "@/utils/EventMgr";
import React, { memo, useCallback, useEffect, useRef } from "react";
import { useGlobalState } from '@/store/commonStore';

const WebSocketCompoent = () => {
    const { isLogin} = useGlobalState()
    const { data } = useBeforeSetting()
    const enterForeGround = useRef(true)
    const activeWsAddrRef = useRef('')
    const connectTimesRef = useRef(0);
    const reconnectSuspendedRef = useRef(false);
    const retryDelayRef = useRef(1000);
    const retryTimerRef = useRef<number>();
    const retryRef = useRef<() => void>(() => undefined);

    const clearRetryTimer = useCallback(() => {
        if (retryTimerRef.current !== undefined) {
            window.clearTimeout(retryTimerRef.current);
            retryTimerRef.current = undefined;
        }
    }, []);

    const scheduleRetry = useCallback(() => {
        clearRetryTimer();
        const delay = retryDelayRef.current;
        retryTimerRef.current = window.setTimeout(() => {
            retryTimerRef.current = undefined;
            retryRef.current();
        }, delay);
        retryDelayRef.current = Math.min(delay * 2, 30000);
    }, [clearRetryTimer]);

    const connectSocket = useCallback(() => {
        if (!enterForeGround.current || reconnectSuspendedRef.current) {
            return
        }
        const token = localStorage.getItem('authToken') || ''
        if (!token || !data?.wsAddr) {
            return
        }
        activeWsAddrRef.current = data.wsAddr;
        SocketMgr.connect(data.wsAddr +'/'+ token, null, () => {
            console.log('链接断开了')
            scheduleRetry();
        }, () => {
            scheduleRetry();
        }, null, () => {
            retryDelayRef.current = 1000;
            clearRetryTimer();
            EventMgr.getInstance().dispatchEvent(EventName.SocketRetrySuccess)
        })
        connectTimesRef.current += 1;
    }, [clearRetryTimer, data, scheduleRetry])

    const retry = useCallback(() => {
        const token = localStorage.getItem('authToken') || ''
        if (isLogin && token && data?.wsAddr && !SocketMgr.isConnection()) {
            connectSocket()
        }
    }, [connectSocket, data, isLogin])
    retryRef.current = retry;

    useEffect(() => {
        const token = localStorage.getItem('authToken') || ''
        if (!isLogin || !token) {
            clearRetryTimer();
            activeWsAddrRef.current = '';
            retryDelayRef.current = 1000;
            SocketMgr.close()
        } else if (data?.wsAddr) {
            reconnectSuspendedRef.current = false;
            if (activeWsAddrRef.current && activeWsAddrRef.current !== data.wsAddr) {
                clearRetryTimer();
                retryDelayRef.current = 1000;
                SocketMgr.close();
                activeWsAddrRef.current = '';
                connectSocket();
            } else {
                retry()
            }
        }
    }, [clearRetryTimer, connectSocket, isLogin, data, retry])


    useEffect(() => {
        EventMgr.getInstance().removeByTarget('SocketReconect')

        EventMgr.getInstance().addEventListener(EventName.EnterForeGround, () => {
            enterForeGround.current = true
            const token = localStorage.getItem('authToken') || ''
            if (isLogin && token && data) {
                if (!SocketMgr.resumeHeartbeatAfterForeground()) {
                    connectSocket()
                }
            } else {
                clearRetryTimer();
                activeWsAddrRef.current = '';
                SocketMgr.close()
            }
        }, 'SocketReconect')
        EventMgr.getInstance().addEventListener(EventName.EnterBackGround, () => {
            enterForeGround.current = false
        }, 'SocketReconect')
        EventMgr.getInstance().addEventListener(EventName.FORCE_LOGOUT, () => {
            reconnectSuspendedRef.current = true;
            clearRetryTimer();
            activeWsAddrRef.current = '';
            retryDelayRef.current = 1000;
            SocketMgr.close();
        }, 'SocketReconect')
        return () => {
            clearRetryTimer();
            EventMgr.getInstance().removeByTarget('SocketReconect')
        }
    }, [clearRetryTimer, connectSocket, isLogin, data])

    return (<div className="socket"></div>)
}

export default memo(WebSocketCompoent)
